import "./_asset-logo.scss";

import {useEffect, useState} from "react";
import classNames from "classnames";

import {getAssetId, getAssetLogo, getAssetPlaceholderLogo} from "../util/assetUtils";
import {useAssetIcons} from "../icon/context/AssetIconContext.utils";
import {DEFAULT_ASSET_LOGO_SIZE} from "./AssetLogo.constants";
import {SimpleAsset} from "../util/assetModels";

export interface AssetLogoProps {
  asset: Pick<SimpleAsset, "name" | "unit_name" | "id">;
  size?: number;
  customClassName?: string;
}

function AssetLogo({
  asset,
  size = DEFAULT_ASSET_LOGO_SIZE,
  customClassName
}: AssetLogoProps) {
  const assetIcons = useAssetIcons();
  const assetId = getAssetId(asset);

  const [displayedSrc, setDisplayedSrc] = useState(getAssetLogo(assetIcons, assetId));

  useEffect(() => {
    setDisplayedSrc(getAssetLogo(assetIcons, assetId));
  }, [assetIcons, assetId]);

  return (
    <img
      className={classNames("asset-logo", customClassName)}
      src={displayedSrc}
      alt={`${asset.name}'s logo`}
      width={size}
      height={size}
      onError={() => setDisplayedSrc(getAssetPlaceholderLogo(assetIcons))}
    />
  );
}

export default AssetLogo;
